export enum ECardErrors {
  GetVillage = 'Error in getVillageData',
  GetVillagePromotions = 'Error in getVillagePromotionsData',
}
